export default __webpack_public_path__ + "static/line-81307f24d84f2b49f0d5cea997a91eb5.png";